import styles from "../../scss/media.module.scss";
import {
  MediaDetailConfig,
  MediaDetailFeatureMapKey,
} from "@/utils/utilFunctions/Mapper/MediaDetailConfig";
import {
  ActionConfigFeatureMapKey,
  getActionConfigFeatures,
} from "@/utils/utilFunctions/Mapper/ActionConfig";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
// import { FileText, Book, Share2, Logs } from 'lucide-react';
import { BookOpen, SquarePen, BookText, Radio, Logs, Book } from "lucide-react";
import { useState } from "react";
import { DRIVE_TAB } from "@/utils/constants/tabConstants";
import { MediaModel } from "@/database";
interface RenderActionItemsProps {
  handleTabChange: (tabName: string, disabled: boolean) => void;
  hasChanges?: boolean;
  paramsFilter?: URLSearchParams;
  isMandatoryMetaFilled?: boolean;
  currentMediaDetailsForEdit: MediaModel;
  selectedTab: string;
  isReadOnlyAccess?: boolean;
}

const actionItems = [
  {
    name: "Details",
    Icon: SquarePen,
    path: "",
    to: "details",
  },
  {
    name: "Social",
    Icon: Radio,
    path: "social-publish",
    to: "social-publish",
  },
  {
    name: "Transcript",
    Icon: BookText,
    path: "transcript",
    to: "transcript",
  },
  // {
  //   name: 'Subtitle',
  //   path: 'subtitle',
  //   Icon: Captions,
  //   to: 'subtitle',
  // },
  {
    name: "Clips",
    Icon: BookOpen,
    path: "clips",
    to: "clips",
  },
  // {
  //   name: "Chapters",
  //   Icon: Book,
  //   path: "chapters",
  //   to: "chapters",
  // },
  {
    name: "Logs",
    Icon: Logs,
    path: "logs",
    to: "logs",
  },
  // {
  //   name: 'Security',
  //   icon: 'bi bi-shield-check',
  //   path: 'security',
  //   to: 'security',
  // },
  // <SquarePen size={48} strokeWidth={1.25} absoluteStrokeWidth />
];

const RenderActionItems = ({
  handleTabChange,
  hasChanges = false,
  selectedTab,
  currentMediaDetailsForEdit,
  isReadOnlyAccess = false,
}: RenderActionItemsProps) => {
  // Get configuration based on media_ref.rel (existing logic)
  const actionConfigFeatures = getActionConfigFeatures(
    currentMediaDetailsForEdit?.media_ref?.rel as ActionConfigFeatureMapKey
  );

  // Additional logic: If asset_type is 'library', disable subtitle and chapters
  const isLibraryAsset =
    currentMediaDetailsForEdit?.asset_type === "library" ||
    (currentMediaDetailsForEdit?.asset_type === "video" &&
      currentMediaDetailsForEdit?.content_type === 2);
  const isPremiereAsset =
    currentMediaDetailsForEdit?.asset_type === "premiere" ||
    currentMediaDetailsForEdit?.media_ref?.rel === "premiere";
  const [showAlert, setShowAlert] = useState(false);
  const [pendingTabChange, setPendingTabChange] = useState<string | null>(null);

  const handleClick = (
    e: React.MouseEvent,
    itemName: string,
    isDisabled: boolean
  ) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }

    if (hasChanges) {
      e.preventDefault();
      setPendingTabChange(itemName);
      setShowAlert(true);
    } else {
      handleTabChange?.(itemName, false);
    }
  };

  const handleConfirmTabChange = () => {
    if (pendingTabChange) {
      handleTabChange?.(pendingTabChange, false);
      setPendingTabChange(null);
    }
    setShowAlert(false);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
    setPendingTabChange(null);
  };
  const resolvedType = isLibraryAsset
    ? DRIVE_TAB
    : currentMediaDetailsForEdit?.asset_type;
  const mediaDetailConfig = MediaDetailConfig(
    resolvedType as MediaDetailFeatureMapKey
  );

  return (
    <>
      <div
        className={`mb-3 p-3 ${styles["mediaInfoNavigation"]}`}
        style={{ listStyle: "none" }}
      >
        {actionItems.map((item) => {
          let isDisabled =
            item.to === "social-publish" &&
            !mediaDetailConfig.social_publish_page.enabled;
          if (currentMediaDetailsForEdit?.media_ref) {
            isDisabled =
              isDisabled ||
              (!actionConfigFeatures["chapters"].enabled &&
                item.to === "clips");
            isDisabled =
              isDisabled ||
              (!actionConfigFeatures["social_publish"].enabled &&
                item.to === "social-publish");
            isDisabled =
              isDisabled ||
              (!actionConfigFeatures["subtitles"].enabled &&
                item.to === "subtitle");
          }
          if (isLibraryAsset) {
            isDisabled = isDisabled || item.to === "subtitle";
            isDisabled = isDisabled || item.to === "clips";
          }
          if (isPremiereAsset) {
            isDisabled = isDisabled || item.to === "social-publish";
          }
          if (isReadOnlyAccess && item.to !== "details") {
            isDisabled = true;
          }
          const isActive = item.to === selectedTab;
          return (
            <div key={item.to}>
              <div
                className={`sidebar-menu-item pointer mb-1 ${
                  isActive ? "active" : ""
                } ${isDisabled ? styles["disabled"] : ""}`}
                onClick={(e) => handleClick(e, item.to, isDisabled)}
                style={
                  isDisabled
                    ? { pointerEvents: "none", opacity: 0.5 }
                    : undefined
                }
              >
                <span className="d-flex align-items-center">
                  <item.Icon
                    size={20}
                    strokeWidth={1.4}
                    style={{ fill: "none", marginRight: "15px" }}
                  />
                  <span className={styles["link-name"]}>{item.name}</span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <AlertDialog
        isOpen={showAlert}
        onClose={handleCloseAlert}
        onConfirm={handleConfirmTabChange}
        title="ALERT!"
        message="You have unsaved changes. Are you sure you want to leave this tab?"
        confirmText="Yes, leave"
        cancelText="No, stay"
        confirmButtonType="warning"
      />
    </>
  );
};

export default RenderActionItems;
